import { AUCTION_EVENTS } from '../../event_bus_modules/auction_bidding';
import { formatAmount } from './auction_formatter';

$(() => {
  const currentBidDisplayElement = $('#current-bid-amount');
  const currentBidLabelElement = $('#current-bid-label');
  const isSTC = $('#_is-stc').val() === 'True';

  const TAGS = {
    HIGHEST_BIDDER: $('#highest-bidder-tag'),
    RESERVE_NOT_MET: $('#reserve-not-met-tag'),
    RESERVE_MET: $('#reserve-met-tag'),
    OUTBID: $('#outbid-tag'),
    STATUS_STC: $('#status-stc-tag'),
  };

  const updateStatusLabels = ({ reserveMet, bidderIds, userBidderId }) => {
    if (!isSTC) {
      // update 'Reserve Met' label
      if (reserveMet) {
        TAGS.RESERVE_MET.removeClass('d-none');
        TAGS.RESERVE_NOT_MET.addClass('d-none');
      } else {
        TAGS.RESERVE_MET.addClass('d-none');
        TAGS.RESERVE_NOT_MET.removeClass('d-none');
      }
    } else {
      if (bidderIds.length) {
        TAGS.STATUS_STC.addClass('tag--green');
      } else {
        TAGS.STATUS_STC.removeClass('tag--green');
      }
    }

    const isUserBidding = bidderIds.includes(userBidderId);
    // update 'Highest Bidder' label
    if (isUserBidding) {
      const winningBidderId = bidderIds[0];
      if (userBidderId === winningBidderId) {
        TAGS.OUTBID.addClass('d-none');
        TAGS.HIGHEST_BIDDER.removeClass('d-none');
        TAGS.HIGHEST_BIDDER.addClass('tag--green');
      } else {
        TAGS.OUTBID.removeClass('d-none');
        TAGS.HIGHEST_BIDDER.addClass('d-none');
      }
    }
  };

  const updateCurrentBid = ({ amount, bids }) => {
    // update current bid amount
    currentBidDisplayElement
      .attr('data-amount', amount)
      .text(formatAmount(amount));

    if (bids.length) {
      currentBidLabelElement.addClass('bid-amount-label--bid-placed');
    }
  };

  EVENT_BUS.on(
    AUCTION_EVENTS.AUCTION_STATUS_UPDATED,
    ({ amount, bidderIds, userBidderId, reserveMet, bids }) => {
      updateCurrentBid({ amount, bids });
      updateStatusLabels({ reserveMet, bidderIds, userBidderId });
    }
  );
});
